import type { ReactNode } from "react";
import { EmptyState, type EmptyStateProps } from "@/shared/ui/emptyState/public";
import { LoadingState, type LoadingStateProps } from "@/shared/ui/loadingState/public";
import styles from "./TableEmptyState.module.css";

// 문장과 요소 노드를 가른다. 문장은 래퍼가 감싸고, 요소 노드는 그 노드가 형태를 소유한다.
export const isTextNode = (node: ReactNode): node is string | number =>
  typeof node === "string" || typeof node === "number";

/**
 * 표·목록의 `emptyMessage` 에 넘기는 빈 상태.
 *
 * c6 는 요소 노드를 문단·여백·면 없이 그대로 놓는다. 그래서 여백은 이 래퍼가 소유한다. 면을 표 본문
 * 안쪽에 띄워 두면 면의 모서리가 표 머리 선과 닿지 않는다. 부모가 나눠 준 높이는 면까지 전달한다.
 */
export function TableEmptyState(props: Omit<EmptyStateProps, "fill">): ReactNode {
  return (
    <div className={styles.inset}>
      <EmptyState {...props} fill />
    </div>
  );
}

/**
 * 표·목록의 `loadingMessage` 에 넘기는 대기 자리.
 *
 * `TableEmptyState` 와 같은 여백을 쓴다. 그래서 대기에서 빈 상태·실패로 바뀔 때 자리가 움직이지 않는다.
 */
export function TableLoadingState(props: Omit<LoadingStateProps, "fill">): ReactNode {
  return (
    <div className={styles.inset}>
      <LoadingState {...props} fill />
    </div>
  );
}
